<template>
    <v-container>
          <v-row dense>
            <v-col
              cols="12" sm="6" md="3"
              v-for="item in visibleActions"
              :key="item.action"
            >
                <!-- Card della stessa altezza nella riga, pulsante sempre in fondo -->
                <v-card class="d-flex flex-column" height="100%">
                  <v-card-title class="report-title">{{ item.name}}</v-card-title>
                  <v-card-text class="flex-grow-1">{{ item.description }}</v-card-text>
                  <v-card-actions>
                    <v-btn
                      :to="{path: `/campaign_report/${item.action}`}"
                    >Vai
                    </v-btn>
                  </v-card-actions>
                </v-card>
            </v-col>
          </v-row>
    </v-container>
</template>
<script>
import { routeNames } from '../../config/router/routeNames';

export default {
  name: 'CampaignReport',
  data() {
    return {
      actions: [

        {
          name: 'REPORT SAGGI',
          action: routeNames.CAMPAIGN_REPORT_SAMPLE,
          description: 'Quante copie di ogni libro sono state assegnate ai docenti nel periodo',
        },

        {
          name: 'REPORT PRENOTATI',
          action: routeNames.CAMPAIGN_REPORT_BOOKED,
          description: 'Libri prenotati per i docenti, in attesa di essere disponibili',
        },

        {
          name: 'ORDINI PRENOTATI',
          action: routeNames.CAMPAIGN_REPORT_BOOKED_ORDER,
          description: 'Ordini ai fornitori creati dai libri prenotati',
          permission: 'manage booked orders',
        },

        {
          name: 'CALCOLI MAGAZZINO',
          action: routeNames.CAMPAIGN_REPORT_ESTIMATES,
          description: 'Quanti libri devono uscire nel periodo e quanti ce ne sono in magazzino',
        },

        {
          name: 'SCARICO SAGGI',
          action: routeNames.CAMPAIGN_REPORT_ALL,
          description: 'Elenco completo dei saggi assegnati, con scuola e stato attuale',
        },

        {
          name: 'REPORT ORDINATI',
          action: routeNames.CAMPAIGN_REPORT_ORDERED,
          description: 'Libri già ordinati per i docenti, con il numero di ordine',
        },

      ],
    };
  },
  computed: {
    visibleActions() {
      const visible = this.actions.filter(item => !item.permission || this.can(item.permission));
      // Calcoli magazzino, il più usato, sempre a destra nella prima riga (4 riquadri per riga),
      // anche per chi non vede Ordini prenotati
      const index = visible.findIndex(item => item.action === routeNames.CAMPAIGN_REPORT_ESTIMATES);
      const [estimates] = visible.splice(index, 1);
      visible.splice(Math.min(3, visible.length), 0, estimates);
      return visible;
    },
  },
};
</script>

<style scoped>
  /* v-card-title spezza le parole a metà (word-break: break-all) */
  .report-title {
    word-break: normal;
  }
</style>
